import React from "react"
import { Divider as MuiDivider, DividerProps } from "@mui/material"

export type PrimitiveDividerProps = DividerProps

export const PrimitiveDivider = (props: PrimitiveDividerProps) => {
	return <MuiDivider {...props} />
}
